var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.163,
    height: 37.163,
    viewBox: "0 0 37.163 37.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 37.163,
    height: 37.163,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M37.163,18.581A18.581,18.581,0,1,1,18.582,0,18.581,18.581,0,0,1,37.163,18.581",
    fill: "#BB9CC0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M12.509,17.369c-.77,0-1.541,0-2.311,0a1.218,1.218,0,0,1-1.313-1.315q0-2.322,0-4.643a1.214,1.214,0,0,1,1.3-1.306q2.341,0,4.684,0A1.21,1.21,0,0,1,16.16,11.4q0,2.341,0,4.684a1.21,1.21,0,0,1-1.278,1.286c-.791,0-1.582,0-2.373,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M18.573,27.059q-4.2,0-8.41,0a1.211,1.211,0,0,1-.15-2.418c.034,0,.068,0,.1,0q8.46,0,16.921,0a1.21,1.21,0,0,1,.131,2.415c-.1.006-.2,0-.307,0H18.573",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M18.6,19.794q4.164,0,8.327.006a1.74,1.74,0,0,1,.69.139,1.175,1.175,0,0,1,.621,1.339,1.218,1.218,0,0,1-1.128.938c-.068.005-.136,0-.2,0q-8.328,0-16.655-.007a1.735,1.735,0,0,1-.745-.165,1.165,1.165,0,0,1-.583-1.337,1.208,1.208,0,0,1,1.1-.911c.1,0,.191,0,.286,0H18.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M23.441,10.1c1.214,0,2.428-.006,3.641,0a1.13,1.13,0,0,1,1.078.712,1.146,1.146,0,0,1-.171,1.265,1.2,1.2,0,0,1-.991.441q-3.568,0-7.139,0a1.542,1.542,0,0,1-.245-.013,1.216,1.216,0,0,1-1.033-1.292,1.2,1.2,0,0,1,1.2-1.113c1.221-.008,2.441,0,3.662,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M23.41,17.369c-1.186,0-2.373,0-3.559,0a1.212,1.212,0,0,1-.123-2.421c.048,0,.1,0,.144,0q3.558,0,7.118,0a1.212,1.212,0,0,1,.224,2.412,3.218,3.218,0,0,1-.326.012H23.41",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIcon);
export default __webpack_public_path__ + "static/media/blogIcon.db7b64f38cd6f70aa10f53398eced5e3.svg";
export { ForwardRef as ReactComponent };